import React, { useEffect } from "react";
import infiniteLoader from "../../assets/loaders/InfinityLoader.gif";

interface IGenerationModalContent {
  isGenerating: boolean;
  error: string | null;
  onSave: (itemName: string) => Promise<void>;
  onClose: () => void;
  generationMessages?: string[];
  generationItemName?: string;
  messageIndex?: number;
  setMessageIndex?: React.Dispatch<React.SetStateAction<number>>;
}

const GenerationModalContent: React.FC<IGenerationModalContent> = ({
  isGenerating,
  error,
  onClose,
  generationMessages = [],
  generationItemName = "item",
  messageIndex = 0,
  setMessageIndex,
}) => {
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isGenerating && setMessageIndex) {
      interval = setInterval(() => {
        setMessageIndex((prev) => (prev + 1) % generationMessages.length);
      }, 2000);
    }
    return () => clearInterval(interval);
  }, [isGenerating, setMessageIndex, generationMessages.length]);

  return (
    <div className="relative bg-white rounded-2xl max-w-md w-full p-6">
      {isGenerating && (
        <div className="flex flex-col items-center space-y-4">
          <img
            src={infiniteLoader}
            alt="Generating..."
            className="w-16 h-16 object-contain"
          />
          <p className="text-base font-medium text-gray-700 text-center">
            {generationMessages[messageIndex] ||
              `Generating ${generationItemName}...`}
          </p>
          <p className="text-sm text-gray-600 text-center">
            You can close this dialog or navigate away. Your{" "}
            {generationItemName} will be saved automatically to your profile
            upon completion.{" "}
            {generationItemName === "catalog" &&
              "A download link will be sent to your registered email and whatsApp"}
          </p>
        </div>
      )}
    </div>
  );
};

export default GenerationModalContent;
